import { omit } from 'lodash';
import getPropKeys from './getPropKeys';

export default function omitProps(props, ...keysOrComponents) {
    const keys = getPropKeys(...keysOrComponents);
    if (keys.length === 0) return props;
    return omit(props, keys);
}
